import { ResponsiveBar } from "@nivo/bar";
import { CustomStackedBar } from "./index";
import { numberFormatter } from "../../../../../../utils";
import { Flex, useBreakpointValue } from "@chakra-ui/react";
import * as React from "react";
import { useEffect, useState } from "react";
import { useAppConfig } from "../../../../../../context";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

function ByYearChart({ chartData, yearsKeys }) {
  const { sidebarState, storedSidebarState } = useAppConfig();

  const [legendItemsX, setLegendItemsX] = useState(1500);
  const { width } = useWindowDimensions();

  const sidebarOpened = useBreakpointValue({
    base: sidebarState,
    lg: storedSidebarState
  });

  useEffect(() => {
    if (!sidebarOpened) {
      setLegendItemsX(width - 320);
    } else {
      setLegendItemsX(width - 520);
    }
  }, [sidebarOpened, width]);

  const CustomLegend = () => {
    return (
      <g>
        <circle cx={legendItemsX} cy="185" r="10" fill={"hsla(50,100%,50%,0.49)"} x="520" y="100" />
        <text x={legendItemsX + 20} y="190" fontSize="11px">Scope 1</text>
        <circle cx={legendItemsX} cy="230" r="10" fill={"hsla(0,100%,50%,0.62)"} x="520" y="200" />
        <text x={legendItemsX + 20} y="235" fontSize="11px">Scope 2</text>
        <circle cx={legendItemsX} cy="275" r="10" fill={"hsl(183,11%,67%)"} x="520" y="300" />
        <text x={legendItemsX + 20} y="280" fontSize="11px">Low value *</text>
      </g>
    );
  };

  return (
    <Flex display={"block"} height={600} width={"100%"}>
      <ResponsiveBar
        margin={{ top: 50, right: 150, bottom: 150, left: 65 }}
        data={chartData}
        indexBy="dimensionItem"
        keys={yearsKeys}
        padding={0.3}
        innerPadding={10}
        barComponent={(barProps) => {
          const barItemData = {
            x: barProps.bar.x,
            y: barProps.bar.y,
            width: barProps.bar.width,
            height: barProps.bar.height,
            data: barProps.bar.data
          };
          return (
            <CustomStackedBar barItemData={barItemData} />
          );
        }}
        groupMode="grouped"
        layers={["grid", "bars", "axes", CustomLegend]}
        axisLeft={{
          tickSize: 0,
          tickPadding: 12,
          legendPosition: "middle",
          legend: "Tonnes of CO2e",
          legendOffset: -50,
          format: value => numberFormatter(value, 2)
        }}
        axisBottom={{
          tickSize: 0,
          tickPadding: 20,
          legendPosition: "middle",
          legendOffset: 40,
          tickRotation: -30
        }}
      />
    </Flex>
  );
}

export default ByYearChart;